// @flow
import DynamicEventsCard from 'components/event/DynamicEventsCard';
import { connect } from 'react-redux';
import type { DispatchType, StateType } from 'types/Actions';
import type { StateProps, DispatchProps, OwnProps } from 'components/event/DynamicEventsCard';

import { fetchEventsPreview } from 'actions/eventsPreviewActions';

const DynamicEventsCardContainer: any = connect(
  (state: StateType, ownProps: $Rest<StateProps, OwnProps>): StateProps => ({
    events: state.eventsPreviewState.events,
    status: state.eventsPreviewState.status,
    ...ownProps
  }),
  (dispatch: DispatchType): DispatchProps => ({
    fetchEvents: () => dispatch(fetchEventsPreview())
  })
)(DynamicEventsCard);

export default DynamicEventsCardContainer;
